import TooltipTemplate from 'backbone/shared/templates/chartist/line_chart_tooltip.js.hamlc'
import UnitsFormatter from 'utils/platform/units_formatter.js'

export class LineChartTooltipView extends Backbone.View
  events:
    "mousemove .ct-chart-line .ct-series"  : "showTooltip"
    "mouseleave .ct-chart-line .ct-series" : "hideTooltip"

  initialize: (options) =>
    @$toolTip = $(".js-tooltip-chartist")
    @$chart = @$el
    @format = @$el.parents(".ct-chart").attr("data-format")
    @units = @$el.parents(".ct-chart").attr("data-units")

    # If the chart shows results of an aggregate function on a data set,
    # @sampleSizeUnits refers to the units of the original data set
    # Example: If the chart shows average time to completion for stories
    # each month, sample size is the number of stories completed each month
    @sampleSizeUnits = @$el.parents(".ct-chart").attr("data-sample-size-units")

    @unitsFormatter = UnitsFormatter
    if @unitsFormatter.hideUnits(@units)
      @units = ""

  showTooltip: (e) =>
    return if @$el.closest(".ct-chart").hasClass("ct-chart-no-tooltips")

    mouseX = e.offsetX

    svgContainer = $(e.currentTarget).parent("svg")
    seriesLength = svgContainer.find(".ct-series").length

    # use .ct-series-b if it exist because data is reversed (last in, most current)
    if seriesLength > 1
      return if $(e.currentTarget).is(".ct-series-a")
      currentDataSeries = svgContainer.find(".ct-series-b")
    else
      currentDataSeries = svgContainer.find(".ct-series-a")

    points = currentDataSeries.find("circle")

    closestPoint = _.min points, (point) ->
      Math.abs(point.cx.baseVal.value - mouseX)

    metaIndex = $(closestPoint).attr("ct:meta")

    @allMeta ||= JSON.parse($(closestPoint).closest(".ct-chart").attr("data-tooltip-meta-data"))
    pointMeta = @allMeta[metaIndex]

    tooltipOptions =
      currentValue: pointMeta.current_value
      currentDisplayUnits: @unitsFormatter.displayUnits(pointMeta.current_value, @format, @units)
      currentDate: pointMeta.current_date
      sampleSize: pointMeta.current_sample_size
      sampleSizeUnits: @unitsFormatter.displayUnits(pointMeta.current_sample_size, @format, @sampleSizeUnits)

    if pointMeta.prior_value?
      formattedChange = @unitsFormatter.formatChange(pointMeta.change)

      $.extend tooltipOptions,
        priorValue:  pointMeta.prior_value
        priorDisplayUnits: @unitsFormatter.displayUnits(pointMeta.prior_value, @format, @units)
        priorDate: pointMeta.prior_date
        change: formattedChange.percent
        changeDirection: formattedChange.direction

    # calculate real left because tooltip should stay inside page frame
    tooltipLeft = Math.round($(closestPoint).offset().left - @$toolTip.outerWidth(true)/2)
    if tooltipLeft < 0
      realLeft = "20px" # this is our bleed
    else
      realLeft = tooltipLeft

    @$toolTip.html(TooltipTemplate(tooltipOptions)).css
      left: realLeft
      top: Math.round($(closestPoint).offset().top - @$toolTip.outerHeight(true) - 11)
    @$toolTip.show()

  hideTooltip: (e) ->
    return if $(e.relatedTarget).is(".js-tooltip-chartist, .js-tooltip-chartist *")
    @$toolTip.hide()



// WEBPACK FOOTER //
// ./app/javascript/backbone/shared/views/chartist/line_chart_tooltip_view.js.coffee